import { IDataPreference, IFiltrosGerais } from "../../@types/type";
import FiltrosGeraisStrategy from "./FiltrosGeraisStrategy";
import { AbstractSaveToApi } from "./types";

export default class SaveFiltrosGeraisToApi extends AbstractSaveToApi<IFiltrosGerais> {
  buildPreference(filtro: IFiltrosGerais): IDataPreference<unknown>[] {
    const preferencia = new FiltrosGeraisStrategy();

    const preferences: IDataPreference<unknown>[] = [];

    if (filtro.range && filtro.range.length > 0) {
      preferences.push(
        preferencia.createRangeInicio(filtro.range[0]),
        preferencia.createRangeFim(filtro.range[1])
      );
    }

    return [
      preferencia.createCompanies(filtro.companies as string[]),
      ...preferences
    ];
  }
}
